import * as gtagClient from './gtag.client.js'

export const enableGtagTracking: (enable?: boolean) => void = gtagClient.enableGtagTracking
export const initGA4: (router: any) => void = gtagClient.initGA4
